<template>
    <div>
        <input type='number' min='1' max='31' v-model="day" />
        <input type='number' min='1' max='31' v-model="month" />
        <input type='number' min='1' max='31' v-model="year" />
    </div>
</template>

<script>
export default {
    name: 'test-component',
    props: {
        value: {

        },
    },
    data() {
        return {
            day: null,
            month: null,
            year: null
        };
    },
    computed: {
        
    },
    watch: {
        "day": function(val) {
            alert("Setting day: " + val);
            this.change();
        },
        "month": function(val) {
            alert("Setting month: " + val);
            this.change();
        },
        "year": function(val) {
            alert("Setting year: " + val);
            this.change();
        },
        "value": {
            immediate: true, 
            handler: function(val, oldVal) {
                alert("Setting date: " + val);
                console.log(parts);
                var parts = ("" + val).split("-");
                this.day = parts[2];
                this.month = parts[1];
                this.year = parts[0];
            },
        }
    },
    methods: {
        change() {
            this.$emit('input', this.year + "-" + this.month + "-" + this.day);
            this.$emit('change', {index: this.$el.dataset.index, value: this.year + "-" + this.month + "-" + this.day});
        }
    },
};
</script>